module.exports = __webpack_public_path__ + "static/media/TOB-perm.18aa27f3.pdf";